import L from "leaflet";

export const canvasRenderer = L.canvas({
  tolerance: 3,
});
